
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/billing-usage",
      function () {
        return require("private-next-pages/portal/billing-usage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/billing-usage"])
      });
    }
  